import { DIVIDER_NAME, isDividerItem } from "~/utils/orderDivider";
import { buildItemCustomSection, joinToppingLabels } from "~/utils/itemCustomLines";
import { appendKitchenPrice } from "~/utils/kitchenItemPrice";
import { supportsItemCustomText } from "~/utils/printerVersion";

interface ValueWithMode {
  showSymbol?: boolean;
  showBahtValue?: boolean;
  showPercentValue?: boolean;
}


export class OrderItemHelper {
  productsStore: any = null;
  constructor(productsStore: any) {
    this.productsStore = productsStore
  }

  getPrinterByUuid(itemUuid: string) {

    const printers = this.productsStore.getPrintersByUuid(itemUuid) || {}

    let printerList = []
    for (const printer of printers) {
      printerList.push(printer)
    }

    if (printerList.length === 0) {
      return []
    }

    return printerList
  }

  sumTopping(item: any) {
    if (item?.toppings) {
      return item.toppings.reduce((acc: any, topping: any) => acc + (topping.price * topping.quantity), 0)
    }
    return 0
  }

  sumToppingForReceipt(item: any) {
    if (item?.Toppings) {
      return item.Toppings.reduce((acc: any, topping: any) => acc + (topping.rice * topping.Quantity), 0)
    }
    return 0
  }


  joinToppingText = (toppings: any) => {
    return joinToppingLabels(toppings)
  }

  joinToppingTextForReceipt = (toppings: any) => {
    return toppings.map((topping: any) => topping.Name).join(", ")
  }

  joinToppingTextNewLine(toppings: any) {
    if (!toppings) {
      return ""
    }
    return toppings.map((item: any, index: number) => {
      return ` ${item.name
        } `
    }).join("\n")
  }

  getBillArrValue(bill: any, index: number) {
    return bill?.[index] || 0;
  }

  transformToppings(toppings: any) {
    if (!toppings) {
      return []
    }

    return toppings.map((item: any, index: number) => {
      const discount = 0
      const discountedPrice = item.price - item.discount
      const extendedPrice = item.discountedPrice * item.quantity

      return {
        toppingId: item.toppingId,
        name: item.name,
        price: item.price,
        discount: item.discount,
        discountedPrice: item.discountedPrice,
        quantity: item.quantity,
        extendedPrice: item.extendedPrice
      }
    })
  }

  getValueWithMode(dataArray: [number, number], { showSymbol, showBahtValue = true, showPercentValue = true }: ValueWithMode = { showSymbol: false }): string {
    if (!dataArray || dataArray.length < 2) {
      return "";
    }

    const [mode, value] = dataArray;
    const absValue = Math.abs(value)

    // Percent Mode => Output to (x%)
    if (mode === 0 && showPercentValue) {
      if (!showSymbol) {
        return absValue.toString();
      }
      return `${absValue}%`;
    }

    // Value Mode => Output to (x฿)
    if (showBahtValue) {
      if (!showSymbol) {
        return absValue.toString();
      }
      return `${absValue}฿`;
    }

    return ""

  }
  getValueWithModeDiscount(dataObj: any, { showSymbol, showBahtValue = true, showPercentValue = true }: ValueWithMode = { showSymbol: false }): string {

    const { mode, value } = dataObj;
    const absValue = Math.abs(value)

    // Percent Mode => Output to (x%)
    if (mode === 0 && showPercentValue) {
      if (!showSymbol) {
        return absValue.toString();
      }
      return `${absValue}%`;
    }

    // Value Mode => Output to (x฿)
    if (showBahtValue) {
      if (!showSymbol) {
        return absValue.toString();
      }
      return `${absValue}฿`;
    }

    return ""

  }

  adapterToppings = (toppings: any) => {
    return toppings.map((topping: any) => {
      return {
        toppingId: topping.toppingId,
        name: topping.name,
        price: topping.price,
        discount: topping.discount,
        discountedPrice: topping.discountedPrice,
        quantity: topping.quantity,
        extendedPrice: topping.extendedPrice
      }
    })
  }

  adapterToppingsForReceipt = (toppings: any) => {
    return toppings.map((topping: any) => {
      return {
        toppingId: topping.toppingId,
        name: topping.name,
        price: topping.price,
        discount: 0,
        discountedPrice: 0,
        quantity: topping.quantity,
        extendedPrice: topping.extendedPrice
      }
    })
  }

  transfromMoveOrderItems(orderItems: any, tableOrigin: string, tableDestination: string) {
    return orderItems.map((item: any, index: any) => {
      const printers = this.getPrinterByUuid(item.subItemId)
      return {
        ...item,
        comments: `(ย้าย ${tableOrigin} ==> ${tableDestination})`,
        tags: printers
      }
    })
  }

  getPrintersListFromItems(items: any) {
    return items.map((item: any) => {
      return this.getPrinterByUuid(item.subItemId)
    })
  }
  // getPrintersListFromItems(items:any){
  //     const printerTagList =  items.map((item:any)=>{
  //         return item.taglist
  //     })

  //     return [...new Set(printerTagList.flat())];
  // }

  /**
   * `opts.showPrice` — print each line's per-unit net price after the item name
   * ("PrintShowPrice" system env). Default OFF, which is what keeps the void and
   * move-table slips (they call this too) exactly as they were.
   */
  buildOrderItems(items: any, opts: { showPrice?: boolean } = {}) {
    const useItemCustomText = supportsItemCustomText()
    const showPrice = opts.showPrice === true

    // Divider ("ตีเส้น") V2 rule: a divider prints on every station THIS order
    // actually touches — i.e. the union of the real items' printer tags — not a
    // global list. Mirrors legacy thermalprinter.v2.js `allPrinterTagsV2`, which
    // accumulated only the tags of the items in the same order.
    const allPrinterTags = [...new Set(
      items
        .filter((item: any) => !isDividerItem(item))
        .flatMap((item: any) => this.getPrinterByUuid(item.subitemid || item.subItemId) || [])
    )]

    return items.map((item: any) => {

      // Divider row: no price/qty math, no toppings/discount, forced onto all the
      // stations this order prints to.
      if (isDividerItem(item)) {
        return {
          ...item,
          name: DIVIDER_NAME,
          quantity: 1,
          price: 0,
          extendedPrice: 0,
          discount: 0,
          discountText: "",
          discountRequest: { mode: 0, value: 0 },
          sumToppings: 0,
          toppings: [],
          toppingList: "",
          toPrinter: 99,
          bill: item.bill || 1,
          tagList: allPrinterTags,
          tags: allPrinterTags,
          check: false,
          by: "",
          isOpenMenu: false,
          listOrderTaker: [],
          qtyToVoid: 0,
          noDiscount: true,
          forceNewLine: true,
          majorSet: 0,
          minorSet: 0,
        }
      }

      const subItemId = item.subitemid || item.subItemId
      const printers = this.getPrinterByUuid(subItemId)
      const discountItem = item.discountrequest || { mode: 0, value: 0 }
      const discountItemAmount = Math.abs(discountItem[2]) || 0
      const discountMode = item.discountrequest?.mode || 0
      const discountValue = item.discountrequest?.value || 0

      // let _comment = '';
      // if (item.isTogo) {
      //   _comment = '<<< TAKE AWAY >>> ';
      // }

      // if (item.comments) {
      //   _comment += item.comments;
      // }

      const itemDiscount = this.getValueWithModeDiscount(discountItem, { showSymbol: true, showBahtValue: false, showPercentValue: true })
      // Baht discounts are per piece → keep the legacy wording `ลด -30.00 X 5`.
      const discountTextLine = discountMode === 1
        ? `ลด -${Number(discountValue).toFixed(2)} X ${item.quantity || 0}`
        : `ลด ${itemDiscount}`

      // On 3.3.4+ the toppings/comments move OUT of the joined strings and into
      // `Custom`; both strings are then blanked so the slip cannot print the
      // same information twice. `toppings` itself stays — it carries the prices
      // behind `sumToppings`, it is not display text.
      const customSection = useItemCustomText ? buildItemCustomSection(item) : undefined

      // Name is otherwise passed straight through from the spread below; this is
      // the only place the kitchen slip rewrites it. Divider rows returned above
      // never reach here, so they keep their own name and print no price.
      const displayName = showPrice ? appendKitchenPrice(item.name || "", item) : undefined

      return {
        ...item,
        ...(displayName !== undefined ? { name: displayName } : {}),
        ...(customSection ? { Custom: customSection } : {}),
        comments: useItemCustomText ? "" : (item.comments || ""),
        discount: discountItemAmount,
        discountText: discountTextLine,
        discountRequest: {
          mode: discountMode,
          value: discountValue
        },
        extendedPrice: item.price || 0,
        sumToppings: this.sumTopping(item),
        toppings: this.adapterToppings(item?.toppings || []),
        toppingList: useItemCustomText ? "" : this.joinToppingText(item?.toppings || []),
        toPrinter: 99,
        bill: 1,
        tagList: printers || [],
        check: false,
        by: "",
        isOpenMenu: false,
        listOrderTaker: [],
        qtyToVoid: item.quantity,
        noDiscount: false,
        forceNewLine: false,
        majorSet: 0,
        minorSet: 0,
        tags: printers,
        // comment: _comment,
        // Comments: _comment
      }
    });
  }


  displayItemDiscountText(mode = 0, value = 0, qty = 0) {


    if (mode == 0) {
      return `ลด ${value}%`
    }

    return `ลด-${value} x ${qty}`
  }
}

export default OrderItemHelper;
